export default "__VITE_ASSET___haaHFSf__"